module.exports = __webpack_public_path__ + "img/back-with-shadow-min.e985fc77.jpg";